/**
 * Formats a doctor's account name with exactly one canonical title.
 *
 * Auth profiles may store names with or without "Dr". Keeping this rule at the
 * display boundary prevents duplicate titles without mutating the account data.
 */
export const formatDoctorDisplayName = (
  name?: string | null,
  fallback = 'Doctor'
): string => {
  let displayName = name?.trim() || fallback.trim() || 'Doctor';

  while (/^dr(?=\.|\s)/i.test(displayName)) {
    displayName = displayName.replace(/^dr(?:\.\s*|\s+)/i, '').trim();
  }

  return `Dr. ${displayName || 'Doctor'}`;
};
